import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, useTheme } from '@mui/material';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';
import langAuthUserActivation from './langs/langAuthUserActivation';
import { globalConfig } from '../../../../app/config/config';

const FUserActivationPresentation = () => {
	const theme = useTheme();
	const { t, i18n } = useTranslation();

	const [isPlaying, setIsPlaying] = useState(false);

	const handlePlayPause = () => {
		setIsPlaying(!isPlaying);
	};

	const [url, setUrl] = useState<string | null>(null);
	useEffect(() => {
		if (i18n) {
			if (i18n.language === 'fr' && globalConfig.get().APP_VIDEO_TUTO_URL_FR !== '') {
				setUrl(globalConfig.get().APP_VIDEO_TUTO_URL_FR);
			} else if (i18n.language === 'en' && globalConfig.get().APP_VIDEO_TUTO_URL_EN !== '') {
				setUrl(globalConfig.get().APP_VIDEO_TUTO_URL_EN);
			} else {
				setUrl(null);
			}
		}
	}, [t, i18n]);

	return (
		<Grid container spacing={0}>
			<Grid item xs={12} sm={6}>
				{url ? (
					<Box
						sx={{
							width: '100%',
							height: { sm: '100%', xs: '340px' },

							backgroundColor: 'black',
						}}
					>
						<ReactPlayer
							playing={isPlaying}
							url={url}
							width="100%"
							height="100%"
							controls
							config={{
								file: {
									attributes: {
										controlsList: 'nodownload',
									},
								},
							}}
						/>
					</Box>
				) : (
					''
				)}
			</Grid>
			<Grid item xs={12} sm={6}>
				<Box
					sx={{
						marginTop: { sm: '100px', xs: '50px' },
						padding: { sm: '0px 60px', xs: '0px 0px' },
						'& .title': {
							fontSize: '0.9rem',
							fontWeight: 600,
							lineHeight: '1.5',
							marginTop: '14px',
						},
						'& .subtitle': {
							fontSize: '0.9rem',
							fontWeight: 400,
							lineHeight: '1.5',
							marginBottom: '14px',
						},
					}}
				>
					<Box
						sx={{
							fontWeight: 400,
							fontSize: '1.2rem',
							lineHeight: '1.5',
						}}
					>
						{t(langAuthUserActivation.text_presentation_title.tag)}
					</Box>
					<Box
						sx={{
							fontWeight: 400,
							fontSize: '1.5rem',
							lineHeight: '1.5',
							'& span.rectContainer': {
								position: 'relative',
								'& span.rect': {
									position: 'absolute',
									width: 'calc(100% + 4px)',
									height: '100%',
									left: '-2px',
									top: '0px',
									background: '#2BD8D5',
									transform: 'rotate(-2deg)',
									zIndex: 10000,
								},
								'& span.rectText': {
									position: 'absolute',
									width: 'calc(100% + 4px)',
									zIndex: 10001,
								},
							},
						}}
					>
						<div
							dangerouslySetInnerHTML={{
								__html: t(langAuthUserActivation.text_with_rect_words.tag, {
									interpolation: { escapeValue: false },
								}),
							}}
						/>
					</Box>

					<Box className="title">{t(langAuthUserActivation.text_presentation_item_1_title.tag)}</Box>
					<Box className="subtitle">{t(langAuthUserActivation.text_presentation_item_1_subtitle.tag)}</Box>
					<Box className="title">{t(langAuthUserActivation.text_presentation_item_2_title.tag)}</Box>
					<Box className="subtitle">{t(langAuthUserActivation.text_presentation_item_2_subtitle.tag)}</Box>
					<Box className="title">{t(langAuthUserActivation.text_presentation_item_3_title.tag)}</Box>
					<Box className="subtitle">{t(langAuthUserActivation.text_presentation_item_3_subtitle.tag)}</Box>
					{url ? (
						<Box
							sx={{
								textAlign: { xs: 'center', sm: 'left' },
								marginBottom: { xs: '50px', sm: '0px' },
							}}
						>
							<Button
								onClick={() => handlePlayPause()}
								color="primary"
								variant="contained"
								size="small"
								startIcon={
									<>
										<AppCustomIcon tag="play" />
									</>
								}
								sx={{
									'& i': {
										fontStyle: 'normal',
										color: theme.palette.secondary.main,
									},
								}}
							>
								{t(langAuthUserActivation.btn_presentation_player.tag)} &nbsp;
								<i>{t(langAuthUserActivation.naming.tag)}</i>
							</Button>
						</Box>
					) : (
						''
					)}
				</Box>
			</Grid>
		</Grid>
	);
};

export default FUserActivationPresentation;
